import React, { Component } from 'react'
import Prompt from './Prompt'

export default class Q extends Component {
  render() {
    return <Prompt color="green" letter="Q" {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Prompts/Q.js